"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inner = exports.Dialog = exports.Content = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Content = exports.Content = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 390
  },
  a: {
    '&:hover, &:focus, &:active': {
      color: theme.palette.common.white
    }
  }
}));
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog)({
  // The Dialog must be above Terms & Conditions popup (The Kendo component #w-terms-and-conditions has its z-index set to 6005).
  // If this value won't be enough, get current z-index value of T&C Kendo popup during the page rendering,
  // increase it and set as the z-index value (something like this `window.getComputedStyle(document.querySelector('.k-window')).zIndex`).
  zIndex: 6050
});
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3)
}));
